/* Solo la guida taglie richiede JS: le tendine usano details/summary nativi. */
(() => {
  if (customElements.get('extro-product-details')) return;
  class ProductDetails extends HTMLElement {
    connectedCallback() {
      this.onAnchor = event => {
        const link = event.target.closest('a[href]');
        if (!link) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || url.hash !== '#guida-taglie') return;
        const scope = link.closest('.product-form');
        if (scope ? !scope.contains(this) : document.querySelector('extro-product-details') !== this) return;
        if (this.openGuide()) event.preventDefault();
      };
      this.onHash = () => { if (location.hash === '#guida-taglie' && document.querySelector('extro-product-details') === this) this.openGuide(); };
      document.addEventListener('click', this.onAnchor);
      window.addEventListener('hashchange', this.onHash);
      this.frame = requestAnimationFrame(this.onHash);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      document.removeEventListener('click', this.onAnchor);
      window.removeEventListener('hashchange', this.onHash);
    }
    openGuide() {
      const guide = this.querySelector('[data-size-guide]');
      if (!guide) return false;
      guide.open = true;
      guide.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      guide.querySelector('summary').focus({ preventScroll: true });
      return true;
    }
  }
  customElements.define('extro-product-details', ProductDetails);
})();
